<template>
    <div class="device">
        <p>device</p>
    </div>
</template>

<script>
export default {
    data(){
        return{
            
        }
    }
}
</script>

<style lang="scss" scoped>
.device{
    
}
</style>